import { z } from 'zod'

import { timestampSchema } from '@/utility'

export const websiteSchema = z.object({
  lastDeployed: timestampSchema,
  subdomainPrefix: z.string().transform((val) => val.toLowerCase()),
  customUrl: z.string().transform((val) => val.toLowerCase()),
  subPath: z.string().optional(),
  title: z.string().optional(),
  description: z.string().optional(),
  favicon: z.string().optional(),
  ogImage: z.string().optional(),
  proxy: z.string().url().optional(),
  routing: z
    .object({
      /**
       * Path replacement pattern for guides.
       * Defaults to `{{version}}/{{guide}}` with version dropped when there is only a single version.
       */
      guidePathPattern: z.string().optional(),
      /**
       * Path replacement pattern for references.
       * Defaults to `{{version}}/{{reference}}` with version dropped when there is only a single version.
       */
      referencePathPattern: z.string().optional(),
    })
    .default({
      guidePathPattern: '',
      referencePathPattern: '',
    }),
  redirects: z
    .array(
      z.object({
        from: z.string(),
        to: z.string(),
      }),
    )
    .default([]),
})

export type Website = z.infer<typeof websiteSchema>

export function defaultWebsite(subdomainPrefix?: string) {
  return websiteSchema.parse({
    lastDeployed: 0,
    subdomainPrefix: subdomainPrefix ?? '',
    customUrl: '',
    title: '',
    description: '',
    favicon: '',
    ogImage: '',
  })
}
